import * as XLSX from 'xlsx';

const COLUMNS = [
  { key: 'time', label: 'Time', width: 20 },
  { key: 'action', label: 'Action', width: 30 },
  { key: 'actor', label: 'Name', width: 24 },
  { key: 'actorEmail', label: 'Email', width: 28 },
  { key: 'actorType', label: 'Actor type', width: 16 },
  { key: 'entity', label: 'Changed item', width: 28 },
  { key: 'portal', label: 'Portal', width: 24 },
  { key: 'source', label: 'Source', width: 12 },
  { key: 'outcome', label: 'Outcome', width: 10 },
  { key: 'summary', label: 'Summary', width: 40 },
  { key: 'ip', label: 'IP address', width: 18 },
  { key: 'ipSource', label: 'IP source', width: 14 },
  { key: 'device', label: 'Browser / device', width: 40 },
  { key: 'metadata', label: 'Details', width: 60 }
];

const actorTypeLabel = (type) => {
  if (type === 'portal_personal') return 'Portal contact';
  if (type === 'portal_shared') return 'Shared portal PIN';
  if (type === 'anonymous') return 'Unknown device';
  return 'BowlScout user';
};

const safeName = (value, fallback) =>
  String(value || fallback)
    .replace(/[^a-z0-9-_]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase() || fallback;

const metadataText = (metadata) => {
  if (!metadata || typeof metadata !== 'object' || Object.keys(metadata).length === 0) {
    return '';
  }
  try {
    return JSON.stringify(metadata);
  } catch {
    return '';
  }
};

const rowForItem = (item) => ({
  time: item.createdAt ? new Date(item.createdAt).toLocaleString() : '',
  action: item.actionLabel || item.action || '',
  actor: item.actor?.name || '',
  actorEmail: item.actor?.email || '',
  actorType: actorTypeLabel(item.actor?.type),
  entity: item.entity?.name || item.entity?.id || '',
  portal: item.scope?.venueName || item.scope?.kind || '',
  source: item.source || '',
  outcome: item.outcome || '',
  summary: item.summary || '',
  ip: item.ip || '',
  ipSource: item.ipSource || '',
  device: item.userAgent || '',
  metadata: metadataText(item.metadata)
});

/**
 * Export the rows currently shown on the audit page. Personal PINs and tokens
 * are never part of audit records, so no credential fields can be exported.
 */
export const exportAuditXlsx = ({ eventName, view, items }) => {
  const rows = Array.isArray(items) ? items : [];
  if (rows.length === 0) return;

  const data = [
    COLUMNS.map((column) => column.label),
    ...rows.map((item) => {
      const values = rowForItem(item);
      return COLUMNS.map((column) => values[column.key] || '');
    })
  ];

  const sheet = XLSX.utils.aoa_to_sheet(data);
  sheet['!cols'] = COLUMNS.map((column) => ({ wch: column.width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    sheet,
    view === 'access' ? 'Portal access' : 'Changes'
  );
  XLSX.writeFile(
    workbook,
    `audit-${view === 'access' ? 'portal-access' : 'changes'}-${safeName(
      eventName,
      'event'
    )}.xlsx`
  );
};

export default exportAuditXlsx;
